import React from "react";

function PV_TimesheetByStaff_Cell_DayProject(props) {
  const {
    tsid,
    day,
    dt_dayFull,
    wt_time,
    tss,
    tte,
    ActProject,
    project_name,
    act_task_timeoff,
    onclick_ModalEditTimeSheet,
    customer_name,
    taskname,
    tasksubname,
    timeoff_name,
    pos_name,
    ee,
    et,
    eo,
    eed,
    etd,
    desc,
    tsssn,
    tsrd,
    ud,
    usn,
    tsd,
    ot_time,
    isSVOT,
  } = props;

  return (
    <>
      <div className="divOuter">
        <div className="divInner">
          {wt_time === "" || wt_time === "00:00" ? (
            ""
          ) : (
            <>
              <div>
                <span className="float-left span-icon">
                

                  {(act_task_timeoff === "T" &&
                          <>
                              <i className="far fa-clock" title="WT"></i>
                          </>
                      ) ||
                      (
                          <>
                            <i className="far fa-pause-circle" title="Time off"></i>
                          </>
                      )}

                </span>
                <span className="span-lable">
                  {wt_time.substring(0, 2) === "00" ? (
                    ""
                  ) : (
                    <>
                      {wt_time.substring(0, 1) === "0" ? (
                        <>
                          {wt_time.substring(1, 2)}
                           <span >h</span> 
                        </>
                      ) : (
                        <>
                          {wt_time.substring(0, 2)}
                           <span >h</span> 
                        </>
                      )}
                    </>
                  )}
                  {wt_time.substring(3) === "00" ? (
                    ""
                  ) : (
                    <>
                      {" "}
                      {parseInt(wt_time.substring(3))}
                      <span >m</span> 
                    </>
                  )}
                </span>
              </div>
            </>
          )}
          {isSVOT && 
            <>
              {ot_time === "" || ot_time === "00:00" ? (
                ""
              ) : (
                <>
                  <div>
                    <span className="float-left span-icon">
                      <i className="far fa-lightbulb" title="OT"></i>
                    </span>
                    <span className="span-lable">
                      {ot_time.substring(0, 2) === "00" ? (
                        ""
                      ) : (
                        <>
                          {ot_time.substring(0, 1) === "0" ? (
                            <>
                              {ot_time.substring(1, 2)}
                               <span >h</span> 
                            </>
                          ) : (
                            <>
                              {ot_time.substring(0, 2)}
                              <span >h</span> 
                            </>
                          )}
                        </>
                      )}
                      {ot_time.substring(3) === "00" ? (
                        ""
                      ) : (
                        <>
                          {" "}
                          {parseInt(ot_time.substring(3))}
                          <span >m</span> 
                        </>
                      )}
                    </span>
                  </div>
                </>
              )}
            </>
          }


          <span className="status-icon">
            {tte > 0 ? <i className="far fa-money-bill-alt" title="Expense"></i> : ""}
          </span>
        </div>
        {(tsid !== 0) && (
          <div className="divOverlap">
            <a
              href="#!"
              title="Edit timesheet"
              data-target="#modal-TimeSheet"
              data-toggle="modal"
              onClick={() =>
                onclick_ModalEditTimeSheet(
                  ActProject,
                  act_task_timeoff,
                  project_name,
                  day,
                  dt_dayFull,
                  customer_name,
                  taskname,
                  tasksubname,
                  timeoff_name,
                  pos_name,
                  ee,
                  et,
                  eo,
                  eed,
                  etd,
                  desc,
                  tsssn,
                  tsrd,
                  ud,
                  tss,
                  usn,
                  tsd,
                  ot_time,
                  wt_time
                )
              }
            >
              <i className="fas fa-pencil-alt fa-lg" />
            </a>
          </div>
        )}
      </div>
    </>
  );
}

export default PV_TimesheetByStaff_Cell_DayProject;
